import { get, post } from '@api/request';

export async function searchDocketGroups(
  { appealsService },
  authenticationToken,
  { payload }
) {
  const url = `${appealsService}/prodigyappeals/agent/docketgroups`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchSearchResultsConfig(
  { appealsService },
  authenticationToken,
) {
  const url = `${appealsService}/prodigyappeals/agent/docketgroups/config/searchresults`;

  const { body } = await get(authenticationToken, url);
  return body;
}
export async function fetchDocketGroupAppeals(
  { appealsService },
  authenticationToken,
  { agentDocketGroupID }
) {
  const url = `${appealsService}/prodigyappeals/agent/docketgroup/${agentDocketGroupID}/appeals`;
  const { body } = await get(authenticationToken, url);
  return body;
}